import { render, staticRenderFns } from "./LeaveApproval.vue?vue&type=template&id=0a028d3d&"
import script from "./LeaveApproval.vue?vue&type=script&lang=js&"
export * from "./LeaveApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a028d3d')) {
      api.createRecord('0a028d3d', component.options)
    } else {
      api.reload('0a028d3d', component.options)
    }
    module.hot.accept("./LeaveApproval.vue?vue&type=template&id=0a028d3d&", function () {
      api.rerender('0a028d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/LeaveManagement/LeaveApproval.vue"
export default component.exports